module.exports = __webpack_public_path__ + "img/arrow_down.36c10fef.fd87aa9a.svg";